export default __webpack_public_path__ + "static/media/include_8_male@3x.b4ac0c57.jpg";